import Swiper, { Navigation,  Pagination } from "swiper";

export const initialiseLatestOffersSliderRedesign = () => {
    const offersSlices = document.querySelectorAll('.cms-content-slice-latest-offers-redesign');
    const offersSliceLength = offersSlices.length;

    if (offersSliceLength <= 0) {
        return;
    }

    for (let index = 0; index <  offersSliceLength; index++) {
        const slider = offersSlices[index].querySelector('.offer-card__swiper');
        const slidesCount = slider.querySelectorAll('.swiper-slide').length;
        const middleIndex = Math.floor(slidesCount / 2);
        if (slider) {
            new Swiper(slider, {
               modules: [Navigation, Pagination],
                grabCursor: true,
                centeredSlides: true,
                loop: true,
                centeredSlides: true,
                slideToClickedSlide: true,
                slidesPerView: 1.1,
                spaceBetween: 16,
           
                watchSlidesProgress: true,
                loopedSlides: slidesCount,
                navigation: {
                    nextEl: '.swiper-offer__slider-nav--next',
                    prevEl: '.swiper-offer__slider-nav--prev',
                },
                pagination: {
                    el: '.swiper-offer__pagination',
                    clickable: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.15,
                    },
                    768: {
                        slidesPerView: 1.4,
                    },
                    1024: {
                        slidesPerView: 1.8,
                    },
                }
            });
        }
    }
}
